import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";

export default function ProDrawer({ open, title, subtitle, icon: Icon, onClose, children, testid = "pro-drawer" }) {
    useEffect(() => {
        if (!open) return undefined;
        const onKey = (e) => { if (e.key === "Escape") onClose(); };
        const prev = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        window.addEventListener("keydown", onKey);
        return () => { document.body.style.overflow = prev; window.removeEventListener("keydown", onKey); };
    }, [open, onClose]);

    if (!open) return null;

    return createPortal(
        <div data-testid={testid} className="fixed inset-0 z-[1000] flex justify-end">
            <div
                data-testid={`${testid}-overlay`}
                onClick={onClose}
                className="absolute inset-0 bg-[#0a1326]/60 backdrop-blur-[3px] animate-in fade-in duration-200"
                aria-hidden="true"
            />
            <aside
                role="dialog"
                aria-modal="true"
                aria-label={title}
                data-testid={`${testid}-panel`}
                className="pro-dash relative flex h-full w-full flex-col bg-ink-950 shadow-[-24px_0_60px_rgba(0,0,0,0.45)] animate-in slide-in-from-right duration-300 sm:w-[94vw] lg:w-[1120px] lg:max-w-[94vw]"
            >
                <header className="flex items-start gap-4 border-b border-[var(--pd-border)] bg-[var(--pd-surface)] px-5 py-4 md:px-8">
                    {Icon && (
                        <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-[var(--pd-icon-bg)] text-[var(--pd-icon)]">
                            <Icon size={20} />
                        </span>
                    )}
                    <div className="min-w-0 flex-1">
                        <h2 data-testid={`${testid}-title`} className="text-base md:text-lg font-semibold leading-tight text-[var(--pd-text)]">{title}</h2>
                        {subtitle && <p className="mt-0.5 text-xs text-[var(--pd-muted)]">{subtitle}</p>}
                    </div>
                    <button
                        type="button"
                        data-testid={`${testid}-close`}
                        onClick={onClose}
                        aria-label="Chiudi pannello"
                        className="grid h-10 w-10 shrink-0 place-items-center rounded-full text-[var(--pd-icon)] hover:bg-[var(--pd-surface-2)] transition-colors"
                    >
                        <X size={18} />
                    </button>
                </header>
                <div data-testid={`${testid}-body`} className="flex-1 overflow-y-auto overscroll-contain px-5 py-6 md:px-8">
                    {children}
                </div>
            </aside>
        </div>,
        document.body,
    );
}
